module.exports = __webpack_public_path__ + "img/logo.e06b8bd9.svg";